import Link from 'next/link';
import Image from 'next/image';
import styled from 'styled-components';
import { useContext } from 'react';
import { DarkModeContext } from '@/pages/_app';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.125rem;
  border-bottom: 1px solid black;
  cursor: pointer;
  z-index: 1;
  position: sticky;
  top: 0;
  :hover {
    background-color: ${(props) => props.theme.colours.hover};
  }
`;

const TextItem = styled.div`
  flex: 1;
`;

function Nav() {
  const { darkMode } = useContext(DarkModeContext);
  function backGroundColour() {
    return darkMode === 'light'
      ? { backgroundColor: '#faf1e7' }
      : { backgroundColor: '#a9a8a8' };
  }
  return (
    <Link href="/" passHref>
      <Container style={backGroundColour()}>
        <Image
          width="37"
          height="50"
          src="/images/neville-goddard.jpg"
          alt="Neville Goddard"
          priority
        />
        <TextItem>&nbsp;Neville Goddard&apos;s Complete Teachings</TextItem>
      </Container>
    </Link>
  );
}

export default Nav;
